import { footerLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-focus-3-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-bold text-lg tracking-wide">
                黑料照片
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-200 max-w-md">
              只对照片本身做技术向真假鉴定：P图痕迹检测、光影对比、原始像素分析与辟谣对照。
              结论分「实锤 / 伪造 / 存疑」三档，吃瓜前先看鉴定，避免被带节奏。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {["ri-weibo-fill", "ri-wechat-fill", "ri-mail-line", "ri-rss-line"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#top"
                    aria-label="社交渠道"
                    className="w-9 h-9 rounded-md bg-secondary-800 text-secondary-100 flex items-center justify-center hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    <i className={icon}></i>
                  </a>
                )
              )}
            </div>
          </div>

          {footerLinks.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.items.map((item) => (
                  <li key={item}>
                    <a
                      href="#top"
                      className="text-sm text-secondary-200 hover:text-accent-300 transition-colors cursor-pointer"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-300">
            © 2026 黑料照片鉴定室 · 仅做技术分析与辟谣对照，不传播未经核实的隐私内容。
          </p>
          <p className="text-xs text-secondary-300">
            鉴定结论仅供参考，如涉及侵权请联系删除。
          </p>
        </div>
      </div>
    </footer>
  );
}